import React from 'react';
import Banner from './Components/banner';
import WedBan from '../../Assets/images/education-web/wedding-ban.png';
import { Col, Container, Row } from 'react-bootstrap';

import ClassicWed from '../../Assets/images/education-web/classic-wed.png';
import CarvedWed from '../../Assets/images/education-web/carved-wed.png';
import DiamondWed from '../../Assets/images/education-web/diamond-wed.png';
import AnnWed from '../../Assets/images/education-web/anni-wed.png';
import EternityWed from '../../Assets/images/education-web/eternity-wed.png';
import Ear from '../../Assets/images/education-web/earring.png';
import Titanium from '../../Assets/images/education-web/titanium.png';
import Ceramic from '../../Assets/images/education-web/cerami.png';
import Cobalt from '../../Assets/images/education-web/cobalt-chrome.png';

import Help from './Components/help';
import Scrollspy from 'react-scrollspy';

import Loose from '../../Assets/images/education-web/loose.svg';
import Ring from '../../Assets/images/education-web/ring.svg';
import Gem from '../../Assets/images/education-web/gems.svg';
import Fine from '../../Assets/images/education-web/fine.svg';
import { Link } from 'react-router-dom';

const WeddingRingEducation = () => {
  return (
    <>
        <Banner title={'Wedding Rings'} bannerImg={WedBan} nestedBreadCrumb />

        <div className='content-wrapper wedding-rings'>
            <Container>
                <ul className='education-tabs'>
                    <li className=''>
                        <Link to="/education/loose-diamonds-education">
                            <img src={Loose} alt='' />
                            <h3>Loose Diamonds</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/engagement-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Engagement Ring</h3>
                        </Link>
                    </li>

                    <li className=''>
                        <Link to="/education/gemstone-education">
                            <img src={Gem} alt='' />
                            <h3>Gemstones</h3>
                        </Link>
                    </li>

                    <li className='active'>
                        <Link to="/education/wedding-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Wedding Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/fine-jewelry-education">
                            <img src={Fine} alt='' />
                            <h3>Fine Jewelry</h3>
                        </Link>
                    </li>
                </ul>
            </Container>

            <Container>
                <h2 className='heading'>Table of Content</h2>
                <ul className='table-of-content mt-4'>
                    <li>
                        <a href="#section-1">
                            <h4>Ring Style</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Ear} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-2">
                            <h4>Alternative Metals</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Ear} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-3">
                            <h4>Find Perfect Wedding Ring</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Ear} alt="" />
                        </a>
                    </li>
                </ul>
            </Container>

            <Row className='m-0 main-content'>
                <Col xl={2} className='d-xl-block d-none'>
                    <div className='sticky-breadcrumb px-5'>
                        <h4>Table of Content</h4>
                        <Scrollspy offset={200} items={ ['section-1', 'section-2', 'section-3', 'section-4'] } currentClassName="is-current">
                            <li><a href="#section-1">Ring Style</a></li>
                            <li><a href="#section-2">Alternative Metals</a></li>
                            <li><a href="#section-3">Find Perfect Wedding Ring</a></li>
                        </Scrollspy>
                    </div>
                </Col>

                <Col xl={8} lg={12}>
                    <Container className=''>
                        <h2 className='heading mt-80' id="section-1">Wedding Ring Styles</h2>
                        <Row className='mt-40'>
                            <Col md={4}>
                                <img src={ClassicWed} alt='' />
                            </Col>
                            <Col className='align-self-center text-md-left text-center'>
                                <h2 className='sub-heading'>Classic Wedding Rings</h2>
                                <p>Classic wedding rings are the perfect choice for newly engaged couples in the market for traditional, timeless rings. Like most bridal jewelry, classic wedding rings come in yellow gold, white gold and platinum. Rings are sold in a variety of widths, ranging from 2mm to 8mm. James Allen carries slightly domed comfort fit wedding rings, slightly flat comfort fit wedding rings, flat comfort fit wedding rings, high dome comfort fit wedding rings, low dome wedding rings, traditional slightly curved wedding rings and classic comfort fit wedding rings.</p>
                                <p>Classic wedding rings are known for their comfort, as opposed to more intricate or carved wedding rings. Unlike engagement rings, both men and women wear wedding rings all the time and therefore it is extremely important that they are comfortable for every day wear.</p>
                            </Col>
                        </Row>

                        <Row className='mt-40'>
                            <Col className='align-self-center order-md-1 order-2 text-md-left text-center'>
                                <h2 className='sub-heading'>Carved Wedding Rings</h2>
                                <p>Women’s carved wedding bands are a popular choice for women who prefer a twist on the classic wedding ring. Carved wedding bands have some sort of carving on them, as opposed to classic wedding rings which are plain and do not have any engravings or patterns. Women with simple or understated engagement rings, often choose to wear intricate carved wedding rings. Carved wedding rings, however, also look striking next to flashy or engagement rings.</p>
                            </Col>
                            <Col md={4} className='order-md-2 order-1'>
                                <img src={CarvedWed} alt='' />
                            </Col>
                        </Row>

                        <Row className='mt-40'>
                            <Col md={4}>
                                <img src={DiamondWed} alt='' />
                            </Col>
                            <Col className='align-self-center text-md-left text-center'>
                                <h2 className='sub-heading'>Diamond Wedding Rings</h2>
                                <p>Women’s diamond wedding rings are a beautiful symbol of a lifelong commitment of two souls coming together. For women who prefer sparkly jewelry, diamond wedding rings are a great choice. Women’s diamond rings come in all shapes and sizes— all metal types and widths. Diamond wedding rings are also a beautiful way to compliment a classic or even carved wedding band. Whether you prefer yellow gold or platinum diamond wedding rings, James Allen has the perfect wedding ring for your special day.</p>
                            </Col>
                        </Row>

                        <Row className='mt-40'>
                            <Col className='align-self-center order-md-1 order-2 text-md-left text-center'>
                                <h2 className='sub-heading'>Anniversary Wedding Rings</h2>
                                <p>Many couples have the tradition of exchanging anniversary rings on their anniversary. For women who love diamond rings, an anniversary ring is the perfect gift to add to her jewelry collection. Women’s anniversary rings come in a range of styles, widths and metal types. Some women prefer platinum anniversary rings, while others prefer yellow gold anniversary rings.</p>
                            </Col>
                            <Col md={4} className='order-md-2 order-1'>
                                <img src={AnnWed} alt='' />
                            </Col>
                        </Row>

                        <Row className='mt-40'>
                            <Col md={4}>
                                <img src={EternityWed} alt='' />
                            </Col>
                            <Col className='align-self-center text-md-left text-center'>
                                <h2 className='sub-heading'>Eternity Wedding Rings</h2>
                                <p>Eternity rings represent eternal, undying love. They are a symbol of a lifelong commitment and union. Women’s eternity rings are the perfect gift for anniversaries, Valentine’s Day and special occasions. Eternity rings are usually encrusted in diamonds and sparkle magnificently when worn alongside your engagement or wedding ring.</p>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            
            <div className='bg-dull grid-section mt-50 py-5' id="section-2">
                <Container>
                    <Row>
                        <Col xl={2}></Col>
                        <Col xl={10}>
                            <h2 className='heading mt-5'>Alternative Metals</h2> 

                            <Row className='mt-50'>
                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Titanium} className='mb-3' width={120} alt="" />
                                    <h2>Titanium</h2>
                                    <p>Titanium rings are very popular, particularly as a men’s wedding ring. Titanium is very durable, lightweight and hypoallergenic, making it a great choice for anyone who suffers from metal allergies. Titanium’s color is slightly darker than that of white gold or platinum. Because of its durability, titanium is usually machined from a single piece of metal (which is why it cannot be used for engagement ring prongs, for example). Titanium rings offer many finishes, such as a brushed finished, a polished finished and a hammered finish.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Ceramic} className='mb-3' width={120} alt="" />
                                    <h2>Ceramic</h2>
                                    <p>Ceramic rings have become more prevalent because of their durability, affordability and wide range of colors. The most popular ceramic wedding ring color is black, offering a sleek and unique look for a wedding band. Ceramic jewelry is also very versatile, as it can be customized into a variety of shapes and sizes.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Cobalt} className='mb-3' width={120} alt="" />
                                    <h2>Cobalt Chrome</h2>
                                    <p>Cobalt chrome is an alloy which is made of cobalt and chromium. The major advantages of cobalt chrome are that it is difficult for it to corrode, scratch or chip. Simultaneously, cobalt chrome is also very malleable, making it very easy to work with. Finally, cobalt chrome is hypoallergenic, making it a wonderful option for anyone who has sensitive skin.</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    
                </Container>
            </div>

            <Container className='mt-50 last-section'>
                <Row>
                    <Col xl={2}></Col>
                    <Col xl={10} className='p-md-0 px-3'>
                        <h2 className='heading' id='section-3'>Finding The Perfect Wedding Ring</h2>

                        <h2 className='sub-heading mt-5'>Finding The Perfect Wedding Rings</h2>
                        <p>Every bride has an idea of what ring she wants and, if possible, the ring that he'll be wearing too. If your man is hesitant about wearing a ring, then put aside your plans for matching bands. Though having rings that match can be a wonderful public expression of your love for each other, that shouldn't be a critical point. Many men find rings to be uncomfortable, so if your platinum round pave set diamond wedding ring doesn't come in an equivalent ring for him, don't fret - wear the ring you want and let him pick out the ring that he likes.</p>

                        <h2 className='sub-heading mt-3'>Traditional, Contemporary, or Both?</h2>
                        <p>Styles of rings vary from the traditional to the contemporary, with many women choosing to blend both. Fashion designers such as M Danhov understand what brides want and that includes diamonds - lots of them! For example, the Ladies 18k White Gold MY4 by Danhov Diamond Wedding Band represents the ultimate wedding band: four rows of 2.15 carats of pave' set diamonds in white gold. Stunningly elegant, yet amazingly refined, rings from the Danhov Collection are admired and desired worldwide.</p>
                        <p>Men have many choices too when it comes to wedding bands. The rules have changed to the point where any man, if he likes them, can have a wedding ring that is encrusted in diamonds too. A customized ring can be made that fits his personality and, if your are one lucky woman, match your ring too. One special note: many men prefer comfort-fit rings, those wedding bands which have rounded inner edges to them.</p>

                        <h2 className='sub-heading mt-3'>When Ordering Your Rings</h2>
                        <p>On-line ring buying has grown in leaps and bounds because consumers have discovered that they can get the same rings through mail order that they can buy at the local jewelry store. Because retailers like James Allen have a small overhead, the savings are passed on to the customer in the form of lower prices. Moreover, in many cases on-line purchases are delivered state tax free, translating into additional savings for the happy couple. That ring selling for $6000 at the mall jewelry shop could retail for under $5000 on-line!</p>
                        <p>No matter where you choose to buy your wedding rings, finding a pair that satisfies you both is very important. Your wedding day is a once in a lifetime event, and a day you'll want to cherish forever. Find the right pair of rings and you'll have a forever reminder of your commitment to each other, rings that will satisfy both husband and wife.</p>
                    </Col>
                </Row>
                
            </Container>    

            <Container>
                <Help />
            </Container>
        </div>
    </>
    
  )
}

export default WeddingRingEducation;